export enum ConnectionStatus {
  Online,
  Offline
}
